import { createSelector } from 'reselect';

const selectTimeZones = (state: any) => state.timeZones;


export const selectTimeZonesCurrentItem = createSelector([selectTimeZones], (timeZones) => timeZones.current);

export const selectTimeZonesListItems = createSelector([selectTimeZones], (timeZones) => timeZones.list);

export const selectTimeZonesItemById = (itemId: any) =>
    createSelector(selectTimeZonesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectTimeZonesCreatedItem = createSelector([selectTimeZones], (timeZones) => timeZones.create);

export const selectTimeZonesUpdatedItem = createSelector([selectTimeZones], (timeZones) => timeZones.update);

export const selectTimeZonesReadItem = createSelector([selectTimeZones], (timeZones) => timeZones.read);

export const selectTimeZonesDeletedItem = createSelector([selectTimeZones], (timeZones) => timeZones.delete);

export const selectTimeZonesSearchedItems = createSelector([selectTimeZones], (timeZones) => timeZones.search);

export const selectTimeZonesItemsCount = createSelector([selectTimeZones], (timeZones) => timeZones.count);

export const selectTimeZonesItemsFilter = createSelector([selectTimeZones], (timeZones) => timeZones.filter);